import { useEffect, useState } from "react"
import Input from "../../../components/Input"
import Map from "../../../components/Map"
import Popup from "../../../components/Popup"
import Select from "../../../components/Select"
import { authAxios } from "../../../helpers/axios"
import ImageInput from "../../../components/ImageInput"
import CropPopup from "../../../components/CropPopup"
import CloseIcon from "../../../images/close.svg"
import { RETAILER_IMAGE_BASE_URL } from "../../../helpers/constants"
import SlidePopup from "../../../components/SlidePopup"
import FilterSelect from "../../../components/FilterSelect"

export default function FilterTea({filters,onSubmit,onClose,clearFilter})
{
    const [selectedFilters,setSelectedFilters] = useState({garden:'',grade:''})
    const [localFilters,setLocalFilters] = useState({gardenId:null,gradeId:null,startDate:null,endDate:null,showEmpty:0,startRate:null,endRate:null,type:null,cityId:null})
    const [gardens,setGardens] = useState([])
    const [grades,setGrades] = useState([])
    const [loading,setLoading] = useState(true)
    const [cities,setCities] = useState([])


    useEffect(()=>
    {
        async function getBuyers(){
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/garden?limit=250&offset=0`)
            setGardens(res.data.data)
            setLoading(false)
            setLocalFilters(filters)
            if(filters.gardenId) setSelectedFilters(data=>{
                return {...data,garden:res.data.data.find(item=>item.id === filters.gardenId)}
            })
        }
        async function getGrades(){
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/grade?limit=250&offset=0`)
            setGrades(res.data)
            if(filters.gradeId) setSelectedFilters(data=>({...data,grade:res.data.find(item=>item.id === filters.gradeId)}))
        }

        async function getCities(){
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/city?limit=250&offset=0`)
            setCities(res.data)
        }
        getBuyers()
        getGrades()
        getCities()
        setLocalFilters(filters)
    },[])





    
    return <><SlidePopup title={'Order Filters'} formName={'filterOrder'} onClose={onClose}>
        {
            loading ?  <p>Loading</p>: 
            <div className="w-full">
            <div className="grid grid-cols-2 gap-x-6 gap-y-6">
                <div>
                    <label>Garden Name</label>
                    <div className='h-[100%]'>
                    <FilterSelect placeholder={'Select Buyer'} options={gardens} value={selectedFilters.garden} customLabel={'name'} customValue={'id'} setValue={(value)=>{setSelectedFilters(data=>({...data,garden:value}));setLocalFilters(data=>({...data,gardenId:value ? value.id : null}))}} padding={false}/>
                </div>
                </div>
                <div>
                    <label>Grade</label>
                    <div className='h-[100%]'>
                    <FilterSelect placeholder={'Select Grade'} options={grades} value={selectedFilters.grade} customLabel={'name'} customValue={'id'} setValue={(value)=>{setSelectedFilters(data=>({...data,grade:value}));setLocalFilters(data=>({...data,gradeId:value ? value.id : null}))}} padding={false}/>
                </div>
                </div>
                <div>
                    <label>Start Date</label>
                    <div className='h-[100%]'>
                    <Input type='date' placeholder={'Select Start Date'} value={localFilters.startDate} setValue={(value)=>setLocalFilters(data=>({...data,startDate:value}))}/>
                </div>
                </div>
                <div>
                    <label>Show Empty</label>
                    <div>
                        <Select options={[{label:'Yes',value:1},{label:'No',value:0}]} customLabel={'label'} customValue={'value'}  value={localFilters.showEmpty === 1 ? 1 : 0} setValue={(value)=>setLocalFilters(data=>({...data,showEmpty:value ? 1 : 0}))}/>
                    </div>
                </div>
                <div>
                    <label>Type</label>
                    <div>
                        <Select options={[{label:'Leaf',value:'leaf'},{label:'Dust',value:'dust'},{label:'Green',value:'green'}]} customLabel={'label'} customValue={'value'}  value={localFilters.type} setValue={(value)=>setLocalFilters(data=>({...data,type:value}))}/>
                    </div>
                </div>
                <div>
                    <label>Place of Origin</label>
                    <div>
                        <Select options={cities} customLabel={'name'} customValue={'id'}  value={localFilters.cityId} setValue={(value)=>setLocalFilters(data=>({...data,cityId:value}))}/>
                    </div>
                </div>
                <div>
                    <label>Start Rate</label>
                    <div className='h-[100%]'>
                    <Input type='number' placeholder={'Select Start Rate'} value={localFilters.startRate} setValue={(value)=>setLocalFilters(data=>({...data,startRate:value}))}/>
                </div>
                </div>
                <div>
                    <label>End Rate</label>
                    <div className='h-[100%]'>
                    <Input type='number' placeholder={'Select End Rate'} value={localFilters.endRate} setValue={(value)=>setLocalFilters(data=>({...data,endRate:value}))}/>
                </div>
                </div>
                <div className='flex justify-end mt-4  w-full col-span-2'>
                    <button type='button' className='btn-md-disabled' onClick={clearFilter}>Clear Filters</button>
                    <button type='submit' className='ml-4 btn-md' onClick={()=>onSubmit(localFilters)}>Filter Orders</button>
                </div>
            </div>
        </div>
        }
    </SlidePopup>
    </>
}



